import React from 'react';
import ReactDOM from 'react-dom';

import { branch } from 'baobab-react/higher-order';
import * as actions from '../../actions/portalActions';

import * as utils from '../../utils/utils';

import { Link } from 'react-router-dom';

import { Button } from 'react-bootstrap';
import { Panel } from 'react-bootstrap';

import Flexbox from 'flexbox-react';

import { HotKeys } from 'react-hotkeys';

import Alerts from '../app-alerts.js';

import HomeLink from './app-home-link.js';

const keyMap = {
	'changePassword': 'enter'
}

class ForgotPassword extends React.Component {
	submit() {
		var username = ReactDOM.findDOMNode(this.refs.username).value;
		var code = ReactDOM.findDOMNode(this.refs.code).value;
		var password = ReactDOM.findDOMNode(this.refs.password).value;

		actions.changeForgottenPasswordForUser(username, code, password);
	};

	render() {
		const handlers = {
			'changePassword': this.submit.bind(this)
		}

		return (
			<HotKeys keyMap={keyMap} handlers={handlers}>
				<Flexbox className="myBackground" flexDirection="column">
					<HomeLink />
					<Flexbox flexDirection="column" alignItems="center" justifyContent="center" flexGrow={1}>
						<Alerts />
						<h1 style={{ marginTop: "120px" }}>Reset Passwort</h1>
						<h3 style={{ color: "#eeeeee", padding: "10px", fontSize: "12pt" }}>Check your email for a verification code.</h3>
						<Panel style={{ marginBottom: "5px", padding: "0px", overflow: "auto" }} className="col-xs-10 col-sm-6 col-md-5 col-lg-4 as-panel-new">
							<Panel.Body>
								<div className="row">
									{/* <div className="col-xs-12">
										<label>Username (case-sensitive)</label>
									</div> */}
									<div className="col-xs-12">
										<input ref="username" style={{ marginBottom: "10px" }} className="form-control" type="text" autoCorrect="off" autoCapitalize="none" defaultValue={this.props.user.username} placeholder='Call-Sign (Case Sensitive Username)' />
									</div>
									{/* <div className="col-xs-12">
										<label>Verification Code</label>
									</div> */}
									<div className="col-xs-12">
										<input autoFocus={utils.isMobile()} ref="code" style={{ marginBottom: "5px" }} className="form-control" type="number" defaultValue="" placeholder="Verification Code" />
									</div>
									{/* <div className="col-xs-12">
										<label>New Password</label>
									</div> */}
									<div className="col-xs-12">
										<input ref="password" style={{ marginBottom: "5px" }} className="form-control" type="password" defaultValue="" placeholder='New Password' />
									</div>
								</div>
								<Button style={{ marginBottom: "5px", color: "black", fontWeight: "bold", fontFamily: 'Syne' }} bsStyle="primary" className="asSignUpBtn" onClick={this.submit.bind(this)}>RESET PASSWORD</Button>
							</Panel.Body>
						</Panel>
						<Link style={{ color: "#eba20e", fontSize: "12pt" }} to="/login">
							<span style={{
								fontFamily: "Syne", color: "white"
							}}>Already have an account? </span> Log In!
						</Link>
						<div style={{ color: "white", padding: "20px", textAlign: "center", width: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
							{this.props.version.copyright}.<br />{this.props.version.prefix}&nbsp;{this.props.version.major}.{this.props.version.minor}.{this.props.version.revision}.{this.props.version.build}&nbsp;{this.props.version.suffix}
						</div>
					</Flexbox>
				</Flexbox>
			</HotKeys>

		);
	}
}

export default branch({
	user: ['user'],
	version: ['version']
}, ForgotPassword);
